import { DecisionsTypePickerSettings } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/DecisionsTypePickerSettings';
import { EpickSettings } from 'components/EntityPicker/EpickSettings';
import { useEffect, useState } from 'react';

export function useTypePickerSettings(settingsProp: DecisionsTypePickerSettings | null = null) {
  const [settings, setSettings] = useState<DecisionsTypePickerSettings | null>(null);

  useEffect(() => {
    EpickSettings.getForDecisionsTypes(settingsProp?.FilterNames).then(
      (defaultSettings: DecisionsTypePickerSettings) => {
        let updatedSettings = defaultSettings;
        if (settingsProp) {
          updatedSettings = { ...updatedSettings, ...settingsProp };
        }
        setSettings(updatedSettings);
      }
    );
  }, [settingsProp]);

  return settings;
}
